import React, { useState, useEffect } from 'react';

import validate from '@vlabs/shared/validators';
import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import { useFilterCount } from '../hooks';

export const FaceIdsInputPopover = ({ customTitle = undefined, onCountChange = undefined }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasAnyError(errors, 'face_ids'));
  }, [errors, errors.face_ids]);

  const faceIds = useWatch({ name: 'face_ids' });
  const filterCount = faceIds ? 1 : 0;
  useFilterCount('face_ids', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="faceIdsFilter"
      triggerValue={customTitle ?? t('id лиц событий')}
    >
      <Control.Input
        id="face_ids"
        label={customTitle ?? t('id лиц событий')}
        {...register('face_ids', { validate: validate.multipleUuid() })}
        errors={errors}
      />
      <Divider small />
      <Control.Button
        disabled={filterCount === 0}
        kind="negative"
        onClick={() => setValue('face_ids', '')}
        size="small"
        variant="filled"
      >
        {t('button.clear')}
      </Control.Button>
    </CustomFilterPopover>
  );
};
